import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../Assets/Slide1/Slide1bg00.png";
import img2 from "../Assets/Slide2/Slide2bg00.png";
import img3 from "../Assets/Slide1/Slide1bg00.png";
import img4 from "../Assets/Slide4.png";
import img5 from "../Assets/carousel/C3.png";
import img6 from "../Assets/carousel/C5.png";
import img7 from "../Assets/carousel/C4.png";
import Navbar from "../components/Navbar";
import bg from "../Assets/Slide3/bgsliderimages.png";
import "./MainPage.css";
import MyNavbar from "./MyNavbar";
import Links from "./Links";
import location from "../Assets/Slide3/LocationGifImg.gif";
import Cards from "./Cards";
import { IoCall } from "react-icons/io5";
import { IoMail } from "react-icons/io5";
import clgname from "../Assets/namelogo.png";
import { FaArrowRight } from "react-icons/fa";
import SlicedSlider from "./SlicedSlider";
import AboutArea from "../components/AboutArea";
import MeetFaculty from "../components/MeetFaculty";
import Courses from "../components/Courses";
import IndustrialConnects from "../components/IndustrialConnects";
import Welcome from "../components/Welcome";
import landline from "../Assets/icons/landlinewhite.png";
const MainPage = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
    arrows: true,
    prevArrow: <div className="custom-prev-arrow">&#8249;</div>,
    nextArrow: <div className="custom-next-arrow">&#8250;</div>,
  };

  return (
    <div className="background-container">
      <div className="bg-[#FF7903] text-white flex justify-end p-2 flex-col items-center sm:flex-row">
        {/* <a href="tel:8096951451"> */}
        <a href="tel:8096951451" className="flex mr-[5%]">
          <p className="pt-1 pr-1">
          <img src={landline} className="w-5" />
          </p>{" "}
          <p>08676-283921,</p>{" "}
          <p className="flex">
           
            <IoCall className="mt-1 mr-1"/>
            8096951451
          </p>
        </a>
        {/* </a> */}
        <div className="flex">
          <p className="pt-1 pr-1">
            <IoMail />
          </p>{" "}
          <a href="mailto:srijyothipolytechnic@gmail.com">
            srijyothipolytechnic@gmail.com
          </a>
        </div>
      </div>

      <div className="flex justify-between flex-col sm:flex-row">
        <div className="w-[80%] sm:w-[80%] m-5">
          <img src={clgname} className="w-full" />
        </div>
        <div className="hidden sm:flex justify-between sm:w-[15%] m-5 mt-10 sm:flex-row flex-col">
          <div className="flex text-3xl text-[#FF7903] ">
            <p className="mr-5 font-Taviraj ml-[-50%] w-[100%]">Find Us</p>
            <p className="mt-1">
              <FaArrowRight />
            </p>
          </div>
          <a href="/RouteMap" className="mt-[-13%]">
            <div>
              <img src={location} className="w-[3%] sm:w-full" />
            </div>
          </a>
        </div>
      </div>

      {/* <a href="/RouteMap">
        <div className="route-map-container">
          <p className="text-[#E97451] text-xl">Route Map</p>
          <hr style={{ border: "1px solid #E97451" }} />
          <div className="w-50 h-50">
            <img src={location} alt="Route Map" />
          </div>
        </div>
      </a> */}

      <div className="mt-[-2%]">
        <MyNavbar />
      </div>
      <div className="">
        <SlicedSlider />
      </div>
      {/* <div className="">
        <Slider {...settings}>
        <div>
            <img src={img5} alt="Slide 3" />
          </div>
          <div>
            <img src={img6} alt="Slide 3" />
          </div>
          <div>
            <img src={img7} alt="Slide 3" />
          </div>
        </Slider>
      </div> */}
      {/* <div>
        <Links />
      </div>
      <div>
        <Cards />
      </div> */}
      {/* <div>
      <Welcome />
      <AboutArea />

      <Courses />
      <IndustrialConnects />
    
      </div> */}
    </div>
  );
};

export default MainPage;
